import React, { useState } from "react";
import { useSelector } from "react-redux";
import { FaChevronLeft, FaChevronRight, FaComments, FaFacebookF, FaPhoneAlt } from "react-icons/fa";
import { SiZalo } from "react-icons/si";
import "../css/floatingContactWidget.css";

/** Nút chat: id trade_web_open_chat để TradeWeb client mở khung chat. */
const CONTACT_ITEMS = [
  {
    id: "facebook",
    label: "Fanpage Facebook",
    href: "https://www.facebook.com/ztovietnam",
    icon: <FaFacebookF size={20} />,
  },
  {
    id: "zalo",
    label: "Chat Zalo",
    href: "https://zalo.me/0364758606",
    icon: <SiZalo size={20} />,
  },
  {
    id: "phone",
    label: "Goi hotline",
    href: "tel:0364758606",
    icon: <FaPhoneAlt size={18} />,
  },
  {
    id: "chat",
    label: "Web chat",
    buttonId: "trade_web_open_chat",
    icon: <FaComments size={20} />,
  },
];

const GUEST_ONLY_IDS = new Set(["facebook", "zalo", "phone"]);
const LOGGED_IN_ONLY_IDS = new Set(["chat"]);
const COLLAPSED_STORAGE_KEY = "zto_floating_contact_collapsed";

const readCollapsed = () => {
  try {
    return localStorage.getItem(COLLAPSED_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};

const writeCollapsed = (value) => {
  try {
    localStorage.setItem(COLLAPSED_STORAGE_KEY, value ? "1" : "0");
  } catch {
    // bỏ qua khi trình duyệt chặn storage
  }
};

const FloatingContactWidget = () => {
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn === true);
  const [collapsed, setCollapsed] = useState(readCollapsed);
  // Chỉ khách đã đăng nhập (nút Web chat) mới thu gọn được vào mép phải.
  const isCollapsed = isLoggedIn && collapsed;

  const toggleCollapsed = () => {
    setCollapsed((prev) => {
      writeCollapsed(!prev);
      return !prev;
    });
  };

  const visibleItems = CONTACT_ITEMS.filter((item) =>
    isLoggedIn
      ? !GUEST_ONLY_IDS.has(item.id)
      : !LOGGED_IN_ONLY_IDS.has(item.id)
  );

  return (
    <div
      className={`floating-contact-widget${isLoggedIn ? " is-collapsible" : ""}${isCollapsed ? " is-collapsed" : ""}`}
      aria-label="Cac kenh lien he nhanh"
    >
      {isLoggedIn && (
        <button
          type="button"
          className="floating-contact-widget__toggle"
          onClick={toggleCollapsed}
          aria-label={isCollapsed ? "Mở web chat" : "Thu gọn web chat"}
          aria-expanded={!isCollapsed}
          title={isCollapsed ? "Mở web chat" : "Thu gọn"}
        >
          {isCollapsed ? <FaChevronLeft size={12} /> : <FaChevronRight size={12} />}
        </button>
      )}
      <div className="floating-contact-widget__items" aria-hidden={isCollapsed || undefined}>
      {visibleItems.map((item) => {
        const isPhone = item.href?.startsWith("tel:");

        if (item.buttonId || !item.href) {
          return (
            <button
              key={item.id}
              type="button"
              id={item.buttonId}
              className={`floating-contact-widget__button floating-contact-widget__button--${item.id}`}
              aria-label={item.label}
              title={item.label}
              tabIndex={isCollapsed ? -1 : undefined}
            >
              <span className="floating-contact-widget__icon">{item.icon}</span>
            </button>
          );
        }

        return (
          <a
            key={item.id}
            href={item.href}
            className={`floating-contact-widget__button floating-contact-widget__button--${item.id}`}
            aria-label={item.label}
            title={item.label}
            target={isPhone ? undefined : "_blank"}
            rel={isPhone ? undefined : "noreferrer"}
          >
            <span className="floating-contact-widget__icon">{item.icon}</span>
          </a>
        );
      })}
      </div>
    </div>
  );
};

export default FloatingContactWidget;
